const config = {
  blacklist: [
    'REDUX_STORAGE_SAVE',
    'REDUX_STORAGE_LOAD',
  ],
};

export default config;
